"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSortFieldOptionsToSelectOptions = exports.sortMethodDate = exports.sortMethodNumber = exports.sortMethodString = exports.sortBySortMethod = exports.SORT_DIRECTION_SELECT_OPTIONS = exports.SORT_DIRECTION = exports.sortNumbers = void 0;
const definedFirstSort_1 = require("./definedFirstSort");
const Text_1 = require("../Text");
const Date_1 = require("../Date");
const sortNumbers = (a, b, increasingOrder = true) => {
    return (0, definedFirstSort_1.definedFirstSort)(a, b, (a, b) => {
        return increasingOrder ? a - b : b - a;
    });
};
exports.sortNumbers = sortNumbers;
var SORT_DIRECTION;
(function (SORT_DIRECTION) {
    SORT_DIRECTION["UP"] = "Vzestupn\u011B";
    SORT_DIRECTION["DOWN"] = "Sestupn\u011B";
})(SORT_DIRECTION || (exports.SORT_DIRECTION = SORT_DIRECTION = {}));
exports.SORT_DIRECTION_SELECT_OPTIONS = [
    { value: SORT_DIRECTION.UP, label: "Vzestupně" },
    { value: SORT_DIRECTION.DOWN, label: "Sestupně" },
];
//TODO add some inverse order if inverse filtering
const sortBySortMethod = (items, func) => {
    return items.slice().sort(func);
};
exports.sortBySortMethod = sortBySortMethod;
const sortMethodString = (get) => {
    return (a, b, increasing) => (0, Text_1.sortStrings)(get(a), get(b), increasing);
};
exports.sortMethodString = sortMethodString;
const sortMethodNumber = (get) => {
    return (a, b, increasing) => (0, exports.sortNumbers)(get(a), get(b), increasing);
};
exports.sortMethodNumber = sortMethodNumber;
const sortMethodDate = (get) => {
    return (a, b, increasing) => (0, Date_1.sortDates)(get(a), get(b), increasing);
};
exports.sortMethodDate = sortMethodDate;
const mapSortFieldOptionsToSelectOptions = (sortOptions) => {
    return Object.entries(sortOptions).map(([key, value]) => {
        return {
            value: key,
            label: value.label
        };
    });
};
exports.mapSortFieldOptionsToSelectOptions = mapSortFieldOptionsToSelectOptions;
